
import {Component} from '@angular/core';

import {environment} from '../../../../../environments/environment';
import {apiParameterInterface} from '../../../interfaces/apiParameter.interface';
import {AppGlobalEventManagerService} from '../../../services/app.globalEventManager.service';
import moment from 'moment/moment';

@Component({
  selector: 'app-footer',
  imports: [],
  standalone: true,
  templateUrl: './footer-partial.html'
})
export class FooterPartial {

  public environnement = environment;
  public year;

  public apiParameters!: apiParameterInterface;

  constructor(
    public appGlobalEventManagerService: AppGlobalEventManagerService,
  ){

    this.year = moment().format('YYYY');
    this.appGlobalEventManagerService.getApiParameters().subscribe((parameters:apiParameterInterface) => {
      this.apiParameters = parameters
    });
  }

}

